import { postRequest, formDataRequest, getRequest } from "../libs/AxiosService.util";

export async function serviceExpenseFetchReport(params) {
  return await postRequest("expense/review", params);
}
export async function serviceExpenseSync(params) {
  return await postRequest("expense/getExpenseEmployees", params);
}
export async function serviceExpenseSummary(params) {
  return await postRequest("expense/getExpenseSummary", params);
}
export async function serviceExpenseGetList(params) {
  return await postRequest("expense/review", params);
}
export async function serviceExpenseApprove(params) {
  return await postRequest("expense/approve", params);
}
export async function serviceExpenseManagerApprove(params) {
  return await formDataRequest("expense/approve", params);
}
export async function serviceExpenseDetail(params) {
  return await postRequest("expense/review/details", params);
}
export async function serviceExpenseDownload(params) {
  return await postRequest("expense/export", params);
}
export async function serviceBankTransfer(params) {
  return await postRequest("expense/bank/transfer/sheet", params);
}
export async function serviceExpenseImportVerify(params) {
  return await formDataRequest("expense/verify", params);
}
export async function serviceExpenseImportFile(params) {
  return await formDataRequest("expense/import", params);
}
export async function serviceExpenseDownloadCsv(params) {
  return await getRequest("expense/sample/csv", params);
}
export async function serviceExpensePendingRequest(params) {
  return await postRequest("expense/review/pending", params);

}